import { useQuery } from "@tanstack/react-query"
import { queries } from "../../queries"

export const usePlanFindQuery = () => {
  return useQuery({ ...queries.plans.find(), retry: false })
}
